/*
  required props {
    onFilterChange: fn,
    getCurrentFilters: fn
  }
*/

// Pretty lame controller I know, mostly just testing out
// this pattern for reusable functionality between React
// components. Seems to work well, just use lodash to merge
// object so something like:
// 
// React.createClass( _.merge(MyController, {
//   custom object code
// }))

var DestinationFilterController = {
    handleOptionChange: function(selected, type) {
      this.state[type].selected = selected;
      this.applyChanges();
    },

    toggleFilterSelections: function(item){
      var filters = this.state.filter.selected,
          itemIndex = filters.indexOf( item );

      if (itemIndex !== -1){
        filters.splice(itemIndex, 1);
      } else {
        filters.push(item);
      }

      //TODO: this isn't good
      this.setState({ filter: this.state.filter });
    },

    applyChanges: function(){
      this.props.onFilterChange(_.clone(this.state, true));
    },

    closeAll: function(){
      this.setState({ currentView: "hidden" });
    },
    
    cancel: function(){
      var guideFilters = this.props.getCurrentFilters().filter,
          filters = this.state.filter;

      filters.selected = _.clone(guideFilters);
      this.setState({ filter: filters });
      this.closeAll();      
    },

    clearFilters: function(){
      var guideFilters = this.props.getCurrentFilters().filter,
          filter = this.state.filter;

      while (filter.selected.length) filter.selected.pop();
      this.setState({ filter: filter });
    }
}

module.exports = DestinationFilterController


// WEBPACK FOOTER //
// ./components/guide-components/destination-filter-controller.js